import React, { FC, useCallback } from "react";
import { LoadingSpinner, PageAlert } from "@xapp/components";
import { logout } from "auth";
import { useGetUserProfileQuery } from "generated/graphql";
import { useDispatch } from "react-redux";
import { Settings } from "../components/Settings";

export const SettingsContainer: FC = () => {

    const [getProfile] = useGetUserProfileQuery({
        requestPolicy: "cache-and-network",
        variables: { }
    });

    const dispatch = useDispatch();

    const handleLogout = useCallback(() => {
        dispatch(logout());
    }, [dispatch]);

    const { data, error, fetching } = getProfile;

    if (fetching) {
        return (<LoadingSpinner loadingText={"Getting your profile"} />);
    }

    if (error) {
        return (<PageAlert background={"orange"}><p>We had an error requesting this information. {error.message} You can try logging in again <a href="/login">here.</a></p></PageAlert>);
    }

    const profile = data.profile;

    return (<Settings profile={profile} onLogout={handleLogout} />);
};
